<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{'PURCHASE_ORDER.RECIEVED_PURCHASE_ORDER_DETAILS' | translate}}</span>
        <span class="soc-pill-lbl soc-neutral-30-pill-outline">{{purchaseOrder.statusType}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="pos-actions-wrapper">
        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.SUPPLIER' | translate}}</label>
            <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.supplier?.name}}</span></div>
        </div>
        <div class="soc-wrapper-gap-24">
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.ISSUE_DATE' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.issuedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
            </div>
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.RECEIPT_DATE' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.receivedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
            </div>
            <div class="soc-display-field-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.INVOICE_NUMBER' | translate}}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.invoiceNumber}}</span></div>
            </div>
        </div>
    </div>
    <p-table *ngIf="purchaseOrder.lineItems" class="soc-borderless-table soc-checkbox-table" [value]="purchaseOrder.lineItems" [(selection)]="selectedItems" [scrollable]="true" scrollHeight="calc(100vh - 462px)">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <p-tableHeaderCheckbox [disabled]="true"></p-tableHeaderCheckbox>
                </th>
                <th>{{'INVENTORY_ITEM.ITEM_NAME' | translate}}</th>
                <th>{{'INVENTORY_ITEM.QUANTITY' | translate}}</th>
                <th>{{'INVENTORY_ITEM.NET' | translate}}</th>
                <th>{{'INVENTORY_ITEM.TAX_RATE' | translate}}</th>
                <th>{{'INVENTORY_ITEM.TAX' | translate}}</th>
                <th>{{'INVENTORY_ITEM.GROSS' | translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
               <td>
                    <p-tableCheckbox [disabled]="true" [value]="item" ></p-tableCheckbox>
                </td>
                <td>{{item.stockItem.name}}</td>
                <td>{{item.quantityReceived != undefined && item.quantityReceived != 0 ? item.quantityReceived + " " + (item.stockItem.unitType | unitShortener | lowercase) : "-"}}</td>
                <td class="secondary-td">{{item.quantityReceived != undefined && item.quantityReceived != 0 ? (currency.shortName ? (item.netPrice | currency: currency.shortName) : item.netPrice) : "-"}}</td>
                <td class="secondary-td">{{item.quantityReceived != undefined && item.quantityReceived != 0 ? item.taxRate.rate + "%" : "-"}}</td>
                <td class="secondary-td">{{item.quantityReceived != undefined && item.quantityReceived != 0 ?  (currency.shortName ? (item.netPrice * item.taxRate.rate / 100 | currency: currency.shortName) : item.netPrice * item.taxRate.rate / 100) : "-"}}</td>
                <td class="secondary-td">{{item.quantityReceived != undefined && item.quantityReceived != 0 ?  (currency.shortName ? (item.netPrice + (item.netPrice * item.taxRate.rate / 100) | currency: currency.shortName) : item.netPrice + (item.netPrice * item.taxRate.rate / 100)) : "-"}}</td>
            </tr>
        </ng-template>
    </p-table>
    
    <hr class="soc-panel-line"/>
    <div class="d-flex align-items-center justify-content-between">
        <button class="soc-secondary-grey-btn" (click)="navigateToMain()"><span class="material-icons-round">arrow_back</span> Back</button>
    </div>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>